import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'modules/styled/web';
import { LinkFont, SecondaryText, View } from 'modules/styled';

ReduxFormField.propTypes = {
  error: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  placeholder: PropTypes.string,
  meta: PropTypes.object,
  input: PropTypes.object,
  autocomplete: PropTypes.string,
};

ReduxFormField.defaultProps = {
  autocomplete: null,
};

function ReduxFormField({ label, type, input, meta, placeholder, autocomplete, form }) {
  const { dirty, touched, error, warning } = meta;
  return (
    <View sx={{ mt: 3 }}>
      {label ? (
        <label html-for={name}>
          <LinkFont sx={{ color: 'black' }}>{label}</LinkFont>
        </label>
      ) : null}
      <Input
        {...input}
        type={type}
        placeholder={placeholder || label}
        autoComplete={autocomplete}
        border={1}
        p="2 2"
        mt={1}
        onBlur={(event) => {
          input.onBlur(event);
          // our mutator accepts variadic field names on which validation will be triggered
          // to trigger validation on more fields, simply pass all its names
          form?.mutators?.triggerValidation(input.name);
        }}
      />
      {(dirty || touched) &&
        ((error && (
          <SecondaryText sx={{ color: 'red', mt: 4.001 }}>{error}</SecondaryText>
        )) ||
          (warning && <SecondaryText sx={{ color: 'red' }}>{warning}</SecondaryText>))}
    </View>
  );
}

export default ReduxFormField;
